import { ConfigService } from './../config-service/config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUser } from '@stockcare-models/IUser';
import { AnalyticsNames } from '@stockcare-helpers/analytics-names';
import { PerformanceMetricService } from '@stockcare-services/performance-metric-service/performance-metric-service';
import { IKeyValue } from '@stockcare-models/IKeyValue';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private http: HttpClient, private conf: ConfigService, private performanceMetricService: PerformanceMetricService) {}

  getAll(): Observable<IUser[]> {
    const startTime = new Date();
    return new Observable((observer) => {
      this.http.get<IUser[]>(`${this.conf.config.baseUrl}/users`).subscribe(
        (result) => {
          observer.next(result);
          this.performanceMetricService.buildAndSubmitMetrics(startTime, AnalyticsNames.userList);
        },
        (error) => observer.error(error)
      );
    });
  }

  create(user: IUser): Observable<IUser> {
    return this.http.post<IUser>(`${this.conf.config.baseUrl}/users`, user);
  }

  update(user: IUser): Observable<string> {
    return this.http.put<string>(`${this.conf.config.baseUrl}/users/${user.id}`, user);
  }

  getUserTypes(): Observable<IKeyValue[]> {
    return this.http.get<IKeyValue[]>(`${this.conf.config.baseUrl}/users/getUserTypes/`);
  }

  remove(user: IUser): Observable<string> {
    return this.http.delete<string>(`${this.conf.config.baseUrl}/users/${user.id}`);
  }

  updateLastLoginDateTime() {
    return this.http.post<string>(`${this.conf.config.baseUrl}/users/UpdateLastLoginDateTime`, {});
  }

  getActiveUsersForInstitution(institutionId: number): Observable<IUser[]> {
    return this.http.get<IUser[]>(`${this.conf.config.baseUrl}/users/getAllActiveUsers/${institutionId}`, {});
  }

  getAllStockUserByInstitutionStockLocation(institutionId: number, stockLocationId: number): Observable<IUser[]> {
    return this.http.get<IUser[]>(`${this.conf.config.baseUrl}/users/GetStockUsers/${institutionId}/${stockLocationId}`, {});
  }
}


